﻿//TN 20240611
import Image from "../image";
import SearchPage from "../searchPage";

export default class DocumentVerification extends SearchPage {

    constructor() {
        super();
        this.image = new Image();
        this.chkAllAct = false;
        this.chkAllNewDoc = false;
        this.defaultResponsibleId = "";
        this.defaultSystems = "";
        this.newDocTabCriteria = null;
        this.docTabCriteria = null;
        this.actionTabCriteria = null;
        this.chckDocVerified = false;
    }

    initializeDocumentVerification() {
        this.cpiStatusMessage = window.cpiStatusMessage;
        $(document).ready(() => {
            $(".container-crumbs").addClass("d-none");
            $("#documentVerification-tab").parent().removeClass("mt-2");

            $('#documentVerification-tab a').on('click', (e) => {
                e.preventDefault();
                const tab = e.target.id;
                
                if (tab == "documentVerificationAction-tab") {
                    $("#actionFilter").removeClass("d-none");
                    $("#systemFilter").removeClass("d-none");
                    $("#actionTypeFilter").removeClass("d-none");
                    $("#responsibleFilter").removeClass("d-none");
                    //$("#checkActFilter").removeClass("d-none");
                    this.refreshActListView();
                }
                else if (tab == "documentVerificationUpload-tab") {                   
                    $("#actionTypeFilter").addClass("d-none");                    
                    $("#actionFilter").addClass("d-none");
                    $("#OrphanDocSystem").removeClass("d-none");
                    //$("#checkActFilter").addClass("d-none");
                    this.refreshNewDocListViewDS();
                }
                else {
                    $("#systemFilter").removeClass("d-none");
                    $("#actionTypeFilter").removeClass("d-none");
                    $("#responsibleFilter").removeClass("d-none");
                    $("#actionFilter").addClass("d-none");
                    $("#OrphanDocSystem").addClass("d-none");
                    //$("#checkActFilter").removeClass("d-none");
                    this.refreshDocListView();
                }
            });

            this.configureDocVerificationTabs();
            this.configureButtons();

            //Add pagers
            $("#documentVerificationContainer").append($("#documentVerificationSearchResults-Grid_pager"));
            $("#newDocVerificationContainer").append($("#documentVerificationNewDocGrid_pager"));
            $("#actionVerificationContainer").append($("#actionVerificationGrid_pager"));

            //Add default responsible criteria        
            if (this.defaultResponsibleId > "" && this.defaultSystems > "") {
                var responsibleMulti = $("#Responsibles").data("kendoMultiSelect");
                if (responsibleMulti) {
                    responsibleMulti.dataSource.read({ systemType: this.defaultSystems });
                    responsibleMulti.value([this.defaultResponsibleId]);
                    responsibleMulti.trigger("change");
                    $("#responsibleFilter").find("div.float-label").removeClass("inactive").addClass("active");

                    //multi select combo issue (slow in selecting values)
                    var docGrid = $("#documentVerificationSearchResults-Grid").data("kendoListView");
                    if (docGrid) {
                        setTimeout(function () {
                            docGrid.dataSource.read();
                        }, 600);
                    }
                }
            }

        });
    }

    configureButtons() {
        //New Docs tab toolbar buttons
        $('#newDocVerificationHeaderContainer').on("click", ".add-doc", () => {
            this.editNewDocument(0);
        });
        $('#newDocVerificationHeaderContainer').on("click", ".select-all-record", (e) => {
            if (this.chkAllNewDoc) {
                this.chkAllNewDoc = false;
                $("input[name='chkNewDocLink']").prop('checked', false);
            }
            else {
                this.chkAllNewDoc = true;
                $("input[name='chkNewDocLink']").prop('checked', true);
            }
        });
        $('#newDocVerificationHeaderContainer').on("click", ".link-doc", (e) => {
            const self = this;

            let url = $("body").data("base-url") + "/Shared/DocumentVerification/SearchLink?";

            var ids = "";
            var docNames = "";
            var alreadyLinked = false;

            $("input[name='chkNewDocLink']:checked").each(function () {
                if (($(this).data('system-type') === '' || $(this).data('system-type') === 'O' || $(this).data('system-type') === null)) {
                    ids += this.value + "|";
                    docNames += $(this).data('doc-name') + "|";
                }
                else {
                    alreadyLinked = true;
                }                
            });

            const container = $('#newDocVerificationContainer');
            const warningMsg = container.data("label-link-warning");
            const errorMsg = container.data("label-link-error");
                        
            if (alreadyLinked) {
                this.cpiAlert.warning(errorMsg);
                return;
            }

            const selectedIds = $.unique(ids.split("|")).join("|");
            if (!selectedIds || selectedIds == "") {                
                this.cpiAlert.warning(warningMsg);
                return;
            }

            var selectedDocs = $.unique(docNames.split("|")).join("|");
            $.get(url, { ids: ids, docNames: selectedDocs })
                .done((result) => {
                    //clear all existing hidden popups to avoid kendo id issue
                    $(".site-content .popup").empty();
                    const popupContainer = $(".site-content .popup").last();
                    popupContainer.html(result);
                    const dialog = $("#searchLinkDialog");
                    dialog.unbind();
                    dialog.modal("show");

                    self.initializeSearchLink();
                })
                .fail(function (error) {
                    pageHelper.showErrors(error);
                });
        });
        $('#newDocVerificationHeaderContainer').on("click", ".delete-doc", (e) => {            
            const self = this;

            const container = $('#newDocVerificationContainer');
            const warningMsg = container.data("label-delete-warning");
            const deleteMsg = container.data("label-delete-msg");
            const deleteHeader = container.data("label-delete-header");

            var ids = "";
            $("input[name='chkNewDocLink']:checked").each(function () {
                ids += this.value + "|";
            });
            const selectedIds = $.unique(ids.split("|").filter(d => d));
            if (!selectedIds || selectedIds.length < 1 || ids === "") {
                this.cpiAlert.warning(warningMsg);
                return;
            }

            let url = $("body").data("base-url");
            url += "/Shared/DocDocuments/DeleteNewVerificationDoc?";
            cpiConfirm.confirm(deleteHeader, deleteMsg, function () {
                $.ajax({
                    type: "POST",
                    url: url,
                    data: { ids: selectedIds },
                    dataType: "json",
                    success: function (response) {
                        if (response.success)
                            self.refreshNewDocListViewDS();
                    },
                    error: function (response) {
                        kendo.alert(response.message);
                    }
                });
            });
        });
        $('#newDocVerificationHeaderContainer').on("click", ".print-record", () => {
            //console.log('Show me the meaning of being lonely');
        });
        $('#newDocVerificationHeaderContainer').on("click", ".excel-export", () => {
            //console.log('Lemon tree');
        });

        //Docs tab toolbar buttons
        $('#documentVerificationHeaderContainer').on("click", ".select-all-doc", (e) => {
            if (this.chckDocVerified) {
                this.chckDocVerified = false;
                $("input[name='chkDocVerified']").prop('checked', false);
            }
            else {
                this.chckDocVerified = true;
                $("input[name='chkDocVerified']").prop('checked', true);
            }
        });
        $('#documentVerificationHeaderContainer').on("click", ".verify-doc", (e) => {
            const self = this;
            let url = $("body").data("base-url") + "/Shared/DocDocuments/VerifyDocuments";
            var docIds = []; 
            
            $("input[name='chkDocVerified']:checked").each(function () {
                docIds.push(this.value);                                  
            });

            const container = $('#documentVerificationContainer');
            const warningMsg = container.data("label-verify-warning");
            //const confirmHeaderLbl = container.data("label-verify-title");
            //const confirmMessageLbl = container.data("label-verify-message");
            
            if (!docIds || docIds.length <= 0) {                
                this.cpiAlert.warning(warningMsg);
                return;
            }   

            self.verifyDoc(docIds);

            //cpiConfirm.confirm(confirmHeaderLbl, confirmMessageLbl, function () {
            //    cpiLoadingSpinner.show();
            //    $.ajax({
            //        type: "POST",
            //        url: url,
            //        data: { docIds: docIds },
            //        dataType: "json",
            //        success: function (response) {
            //            cpiLoadingSpinner.hide();
            //            pageHelper.handleEmailWorkflow(response);
            //            self.refreshDocListView();
            //        },
            //        error: function (response) {
            //            cpiLoadingSpinner.hide();
            //            pageHelper.showErrors(response.message);
            //        }
            //    });
            //});
        });

        //Actions tab toolbar buttons
        $('#actionVerificationContainer').on("click", ".print-record", () => {
            //console.log('What is love? Baby dont hurt me');
        });
        $('#actionVerificationContainer').on("click", ".excel-export", () => {
            //console.log('Put your head on my shoulder');
        });
        $("#actionVerificationContainer").on("click", ".act-verify-icon", (e) => {
            e.preventDefault();
            const el = $(e.currentTarget);
            const id = el.data("u-id");
            const verifyRow = el.closest(".family-header").next();

            verifyRow.find(`#verify_edit_${id}`).removeClass("d-none");
            
            var dateVerifiedEntry = verifyRow.find(".verified-date-entry");
            if (dateVerifiedEntry) {
                var dateVerified = $(dateVerifiedEntry).data("value");
                if ($(`#VerifiedDate_${id}`).data("kendoDatePicker") !== undefined) {
                    $(`#VerifiedDate_${id}`).data("kendoDatePicker").destroy(); 
                }
                $(`#VerifiedDate_${id}`).kendoDatePicker({                
                    "format": "dd-MMM-yyyy",
                    "max": new Date(9999, 11, 31, 0, 0, 0, 0),
                    "min": new Date(1800, 0, 1, 0, 0, 0, 0),
                    "parseFormats": ["{0:dd-MMM-yyyy}", "d", "M d yyyy", "M/d/yyyy", "M-d-yyyy", "M.d.yyyy", "MMMM d, yyyy", "MMMM d yyyy", "d MMMM, yyyy", "d MMMM yyyy", "MMM d, yyyy", "MMM. d, yyyy", "M d yy", "M/d/yy", "M-d-yy", "M.d.yy", "M d", "M/d", "M-d", "M.d", "yyyy-M-d"] 
                });
                if (dateVerified) {
                    $(`#VerifiedDate_${id}`).data("kendoDatePicker").value(new Date(dateVerified));
                }
            }


            el.hide();
        });
        $("#actionVerificationContainer").on("click", ".set-current-date-verify-icon", (e) => {
            const parent = $(e.currentTarget).parents(".edit-verify");
            const id = parent.attr("id").split("_")[2];
            const verifiedDatePicker = $(`#VerifiedDate_${id}`).data("kendoDatePicker");
            if (verifiedDatePicker) {
                verifiedDatePicker.value(new Date());
            }
        });
        $("#actionVerificationContainer").on("click", ".save-verify-icon", (e) => {
            this.saveVerify(e);
        });
        $("#actionVerificationContainer").on("click", ".cancel-verify-icon", (e) => {
            this.hideEditVerify(e);
        });
        $('#actionVerificationContainer').on("click", ".select-all-record", (e) => {
            if (this.chkAllAct) {
                this.chkAllAct = false;
                $("input[name='chkActVerify']:enabled").prop('checked', false);
            }
            else {
                this.chkAllAct = true;
                $("input[name='chkActVerify']:enabled").prop('checked', true);
            }
        });
        $('#actionVerificationContainer').on("click", ".verify-record", (e) => {
            this.showVerifyEditor(e);
        });
    }

    verifyDoc(docIds) {      
        const self = this;
        if (docIds) {            
            let url = $("body").data("base-url") + "/Shared/DocDocuments/VerifyDocuments";

            const container = $('#documentVerificationContainer');
            const confirmHeaderLbl = container.data("label-verify-title");
            const confirmMessageLbl = container.data("label-verify-message");
            cpiConfirm.confirm(confirmHeaderLbl, confirmMessageLbl, function () {
                cpiLoadingSpinner.show();
                $.ajax({
                    type: "POST",
                    url: url,
                    data: { docIds: docIds },
                    dataType: "json",
                    success: function (response) {
                        cpiLoadingSpinner.hide();
                        pageHelper.handleEmailWorkflow(response);
                        self.refreshDocListView();
                    },
                    error: function (response) {
                        cpiLoadingSpinner.hide();
                        pageHelper.showErrors(response.message);
                    }
                });
            });
        }
    }

    //Actions tab - START
    configureDocVerificationTabs() {

        //Configure New Documents tab
        this.configureNewDocSort();

        //Configure Documents tab
        this.configureColumnSort();

        //Configure Actions tab - start
        this.configureActColumnSort();
    }

    saveVerify(e) {
        const self = this;
        let url = $("body").data("base-url") + "/Shared/DocumentVerification/SaveActionVerify";

        const parent = $(e.currentTarget).parents(".edit-verify");
        const id = parent.attr("id").split("_")[2];
        const actId = $(`#ActId_${id}`);
        const system = $(`#System_${id}`);
        const verifiedDate = $(`#VerifiedDate_${id}`);

        var data = { actId: actId.val(), system: system.val(), verifiedDate: verifiedDate.val() };

        //const remarks = form.find("[name='DueDateRemarks']").val();
        $.ajax({
            type: "POST",
            url: url,
            data: data,
            success: (tStamp) => {
                //timeStamp.val(tStamp);
                this.hideEditVerify(e);
                self.refreshActListView();
                //this.hideEditVerify(e, "save", remarks);

                //const remarksIcon = $(`#remarks_icon_${id}`);
                //if (remarks) {
                //    remarksIcon.addClass("fa-comment-alt-lines");
                //    remarksIcon.removeClass("fa-comment-alt")
                //}
                //else {
                //    remarksIcon.removeClass("fa-comment-alt-lines");
                //    remarksIcon.addClass("fa-comment-alt")
                //}
            },
            error: function (e) {
                pageHelper.showErrors(e);
            }
        });
    }

    hideEditVerify(e) {
        e.preventDefault();
        const parent = $(e.currentTarget).parents(".edit-verify");
        parent.addClass("d-none");
        const id = parent.attr("id").split("_")[2];
        $(`#verify_icon_${id}`).show();
        //if (action === "save") {            
        //    $(`#form_${id}`).find("[name='DueDateRemarks']").val(remarks);
        //}
    }

    configureActColumnSort() {
        const container = $("#dvActionHeaderContainer");

        const actionType = container.find("#Act_DueDate");
        actionType.append('<span id="Act_DueDateSortIcon" class="k-icon k-i-sort-asc-sm"></span>');

        const self = this;
        container.find("a").each(function () {
            const event = $(this);
            const id = $(this).attr("id");

            $("#" + id).on('click', function () {
                self.addActSortIcon(event);
            });
        });
    }

    addActSortIcon(event) {
        const sortAscIcon = "k-icon k-i-sort-asc-sm";
        const sortDescIcon = "k-icon k-i-sort-desc-sm";
        let sortOrder = "ASC";
        const sortColumn = event.attr("id");
        const sortIconId = sortColumn + "SortIcon";
        const sortIcon = $("#" + sortIconId);

        this.hideActSortIcons(sortColumn);

        if (sortIcon.length === 0) {
            event.append("<span id=" + sortIconId + " class='" + sortAscIcon + "'></span>");
        }
        else {
            const spanClass = sortIcon.attr("class");
            if (spanClass === undefined) {
                sortIcon.addClass(sortAscIcon);
            }
            else if (spanClass === sortAscIcon) {
                sortIcon.removeClass().addClass(sortDescIcon);
                sortOrder = "DESC";
            }
            else {
                sortIcon.removeClass().addClass(sortAscIcon);
            }
        }

        this.refreshActListView(sortColumn, sortOrder);
    }

    hideActSortIcons(columnClicked) {
        const headerContainer = $("#dvActionHeaderContainer");
        headerContainer.find("a").each(function () {
            const column = $(this).attr("id");

            // hide Sort icons except column clicked 
            if (columnClicked !== column) {
                const sortIcon = $("#" + column + "SortIcon");
                if (sortIcon.length > 0) {
                    sortIcon.removeClass();
                }
            }
        });
    }

    refreshActListView(sortColumn = "DueDate", sortOrder = "ASC") {
        sortColumn = sortColumn.replace("Act_", "");
        const dataSource = $('#actionVerificationGrid').data('kendoListView').dataSource;
        const sortDescriptor = [{ field: sortColumn, dir: sortOrder.toLowerCase() }];
        var container = $(this.refineSearchContainer);
        container.find("#SortCol").val(sortColumn);
        container.find("#SortOrder").val(sortOrder);
        const query = {
            sort: sortDescriptor,
            page: dataSource.page(),
            pageSize: dataSource.pageSize()
        };
        dataSource.query(query);
    }

    actionDataBound = (e) => {
        const data = e.sender.dataSource.data();
        $(".family-wrap").remove();
        if (data.length > 0) {
            const listView = e.sender.element;
            const rows = listView.find(".tickler-row");
            let family = "";

            for (var i = 0; i < rows.length; i++) {
                const row = rows[i];
                const rowData = data[i];

                //if (i % 2)
                //    $(row).addClass("k-alt");

                if (rowData.DocId === 0 && rowData.ComputerGenerated === false) {
                    var verifyIcon = $("#verify_icon_" + rowData.UId);
                    if (verifyIcon)
                        verifyIcon.addClass("d-none");

                    var verifyChkbx = $("#chkActVerify_" + rowData.ActId);
                    if (verifyChkbx) {
                        verifyChkbx.prop("disabled", true);
                        verifyChkbx.addClass("d-none");
                    }                        
                }

                if (family !== rowData.FamilyId) {
                    family = rowData.FamilyId;
                    listView.append(`<div class="family-wrap" data-familyid="${family}"><div class="family-detail"></div></div>`);
                    $(row).appendTo($(`div[data-familyid='${family}'] .family-detail`));
                }
                else {
                    $(row).appendTo($(`div[data-familyid='${family}'] .family-detail`));
                    //$(row).removeClass("k-alt");
                }
            }
        }
    }

    showVerifyEditor = (e) => {
        const self = this;
        const tickler = $('#actionVerificationContainer').find(".tickler");
        const url = tickler.data("save-verify-url");
        const validationError = tickler.data("validation-error");

        const popUpContent = `<div class="form-row justify-content-center"><div class="col-8">        
            <div class="form-group float-label">
                <label for="VerifiedDate_Popup">${tickler.data("label-verify-date")}</label>
                <input id="VerifiedDate_Popup" title="VerifiedDate_Popup" required/>    
                <span class="field-validation-error" style="display:none;" data-valmsg-for="VerifiedDate_Popup"><span id="VerifiedDate_Popup-error">${validationError}</span></span>
                <script>
	                $(document).ready(function() {               
                        $("#VerifiedDate_Popup").kendoDatePicker({
                            value: new Date(), 
                            format: "dd-MMM-yyyy"
                        });                        
                    });
                </script>
            </div></div>`;

        var tempIds = "";
        $("input[name='chkActVerify']:enabled:checked").each(function () {
            tempIds += this.value + "|";
        });

        const selectedIds = $.unique(tempIds.split("|")).join("|");
        if (!selectedIds || selectedIds == "") {
            this.cpiAlert.warning(tickler.data("label-verify-warning"));
            return;
        }

        if (url) {
            cpiConfirm.save(tickler.data("label-verify-title"), popUpContent,
                function () {
                    const verifiedDatePicker = $("#VerifiedDate_Popup").data("kendoDatePicker");
                    const selectedDate = verifiedDatePicker.value();
                    const reason = $(`input[id=VerifiedDate_Popup]`);
                    const error = $(`#VerifiedDate_Popup-error`).closest(".field-validation-error");

                    if (selectedDate) {
                        error.hide();
                        reason.removeClass("input-validation-error");

                        cpiLoadingSpinner.show();

                        const data = {
                            verifiedDate: selectedDate.toJSON(),
                            selectedIds: selectedIds,
                            __RequestVerificationToken: tickler.find("input[name=__RequestVerificationToken]").val()
                        };

                        $.post(url, data)
                            .done(function (result) {
                                cpiLoadingSpinner.hide();
                                self.refreshActListView();
                            })
                            .fail((error) => {
                                cpiLoadingSpinner.hide();
                                pageHelper.showErrors(error)
                            });
                    }
                    else {
                        error.show();
                        reason.addClass("input-validation-error");
                        reason.focus();
                        throw validationError;
                    }
                }
            );
        }
    }
    //Actions tab - END


    //Documents tab - START
    configureColumnSort() {
        const container = $("#dvHeaderContainer");

        const docName = container.find("#Doc_UploadedDate");
        docName.append('<span id="Doc_UploadedDateSortIcon" class="k-icon k-i-sort-asc-sm"></span>');

        const self = this;
        container.find("a").each(function () {
            const event = $(this);
            const id = $(this).attr("id");

            $("#" + id).on('click', function () {
                self.addSortIcon(event);
            });
        });
    }

    addSortIcon(event) {
        const sortAscIcon = "k-icon k-i-sort-asc-sm";
        const sortDescIcon = "k-icon k-i-sort-desc-sm";
        let sortOrder = "ASC";
        const sortColumn = event.attr("id");
        const sortIconId = sortColumn + "SortIcon";
        const sortIcon = $("#" + sortIconId);

        this.hideSortIcons(sortColumn);

        if (sortIcon.length === 0) {
            event.append("<span id=" + sortIconId + " class='" + sortAscIcon + "'></span>");
        }
        else {
            const spanClass = sortIcon.attr("class");
            if (spanClass === undefined) {
                sortIcon.addClass(sortAscIcon);
            }
            else if (spanClass === sortAscIcon) {
                sortIcon.removeClass().addClass(sortDescIcon);
                sortOrder = "DESC";
            }
            else {
                sortIcon.removeClass().addClass(sortAscIcon);
            }
        }

        this.refreshDocListView(sortColumn, sortOrder);
    }

    hideSortIcons(columnClicked) {
        const headerContainer = $("#dvHeaderContainer");
        headerContainer.find("a").each(function () {
            const column = $(this).attr("id");

            // hide Sort icons except column clicked 
            if (columnClicked !== column) {
                const sortIcon = $("#" + column + "SortIcon");
                if (sortIcon.length > 0) {
                    sortIcon.removeClass();
                }
            }
        });
    }

    refreshDocListView(sortColumn = "UploadedDate", sortOrder = "ASC") {
        sortColumn = sortColumn.replace("Doc_", "");
        const dataSource = $('#documentVerificationSearchResults-Grid').data('kendoListView').dataSource;
        const sortDescriptor = [{ field: sortColumn, dir: sortOrder.toLowerCase() }];
        var container = $(this.refineSearchContainer);
        container.find("#SortCol").val(sortColumn);
        container.find("#SortOrder").val(sortOrder);
        const query = {
            sort: sortDescriptor,
            page: dataSource.page(),
            pageSize: dataSource.pageSize()
        };
        dataSource.query(query);
    }

    dataBound() {
        const self = this;
        let highlightRow = 3;
        $("#documentVerificationSearchResults-Grid tr").each(function (index) {
            //if (index % 2) {
            //    $(this).addClass("k-alt");
            //}            
            const row = index + 1;
            if (row >= highlightRow && row <= highlightRow + 1) {
                $(this).addClass("altItem");

                if (row === highlightRow + 1)
                    highlightRow = highlightRow + 4;
            }
        });

        //refresh the actions tab also
        const actionGrid = $('#actionVerificationGrid');
        if (actionGrid.length > 0) {
            cpiLoadingSpinner.show("", 1);
            actionGrid.data("kendoListView").dataSource.read().then(cpiLoadingSpinner.hide());
        }

        //refresh the new documents tab also
        const newDocGrid = $('#documentVerificationNewDocGrid');
        if (newDocGrid.length > 0) {
            cpiLoadingSpinner.show("", 1);
            const newDocDS = newDocGrid.data("kendoListView").dataSource;
            if (newDocDS.page() != 1) {
                newDocDS.page(1);
            }               
            newDocDS.read().then(cpiLoadingSpinner.hide());
        }
    }

    deleteLinkedAction(verifyId) {
        const self = this;
        const container = $('#documentVerificationContainer');
        const deleteMsg = container.data("label-delete-msg");
        const deleteHeader = container.data("label-delete-header");
        let url = $("body").data("base-url") + "/Shared/DocumentVerification/DeleteLinkedAction?";

        cpiConfirm.confirm(deleteHeader, deleteMsg, function () {
            $.ajax({
                type: "POST",
                url: url,
                data: { verifyIds: [verifyId] },
                dataType: "json",
                success: function (response) {
                    if (response.success)
                        self.refreshDocListView();
                },
                error: function (response) {
                    kendo.alert(response.message);
                }
            });
        });
    }
    //Documents tab - END


    //New Documents tab - START
    configureNewDocSort() {
        const container = $("#ndHeaderContainer");

        const uploadDateCol = container.find("#NewDoc_UploadedDate");
        uploadDateCol.append('<span id="NewDoc_UploadedDateSortIcon" class="k-icon k-i-sort-desc-sm"></span>');

        const self = this;
        container.find("a").each(function () {
            const event = $(this);
            const id = $(this).attr("id");
            $("#" + id).on('click', function () {
                self.addNewDocSortIcon(event);
            });
        });
    }

    addNewDocSortIcon(event) {
        const sortAscIcon = "k-icon k-i-sort-asc-sm";
        const sortDescIcon = "k-icon k-i-sort-desc-sm";
        let sortOrder = "ASC";
        const sortColumn = event.attr("id");
        const sortIconId = sortColumn + "SortIcon";
        const sortIcon = $("#" + sortIconId);

        this.hideNewDocSortIcons(sortColumn);

        if (sortIcon.length === 0) {
            event.append("<span id=" + sortIconId + " class='" + sortAscIcon + "'></span>");
        }
        else {
            const spanClass = sortIcon.attr("class");
            if (spanClass === undefined) {
                sortIcon.addClass(sortAscIcon);
            }
            else if (spanClass === sortAscIcon) {
                sortIcon.removeClass().addClass(sortDescIcon);
                sortOrder = "DESC";
            }
            else {
                sortIcon.removeClass().addClass(sortAscIcon);
            }
        }

        this.refreshNewDocListView(sortColumn, sortOrder);
    }

    hideNewDocSortIcons(columnClicked) {
        const headerContainer = $("#ndHeaderContainer");
        headerContainer.find("a").each(function () {
            const column = $(this).attr("id");

            // hide Sort icons except column clicked 
            if (columnClicked !== column) {
                const sortIcon = $("#" + column + "SortIcon");
                if (sortIcon.length > 0) {
                    sortIcon.removeClass();
                }
            }
        });
    }

    refreshNewDocListView(sortColumn = "UploadedDate", sortOrder = "DESC") {
        sortColumn = sortColumn.replace("NewDoc_", "");
        const dataSource = $('#documentVerificationNewDocGrid').data('kendoListView').dataSource;
        const sortDescriptor = [{ field: sortColumn, dir: sortOrder.toLowerCase() }];
        var container = $(this.refineSearchContainer);
        container.find("#SortCol").val(sortColumn);
        container.find("#SortOrder").val(sortOrder); 
        const query = {
            sort: sortDescriptor,
            page: dataSource.page(),
            pageSize: dataSource.pageSize()
        };
        dataSource.query(query);
    }

    refreshNewDocListViewDS() {
        const gridDS = $('#documentVerificationNewDocGrid').data('kendoListView').dataSource;        
        gridDS.read();        
    }
    
    newDocDataBound(recRows) {
        $("#documentVerificationNewDocGrid tr").each(function (index) {
            if (index % 2) {
                $(this).addClass("k-alt");
            }
        });
    }

    deleteNewDocument(id) {
        const self = this;
        const container = $('#newDocVerificationContainer');
        const deleteMsg = container.data("label-delete-msg");
        const deleteHeader = container.data("label-delete-header");
        let url = $("body").data("base-url") + "/Shared/DocDocuments/DeleteNewVerificationDoc?";            

        cpiConfirm.confirm(deleteHeader, deleteMsg, function () {
            $.ajax({
                type: "POST",
                url: url,
                data: { ids: [id] },
                dataType: "json",
                success: function (response) {
                    if (response.success)
                        self.refreshNewDocListViewDS();
                },
                error: function (response) {
                    kendo.alert(response.message);
                }
            });
        });
    }

    linkRecord(id, docName) {
        const self = this;
        let url = $("body").data("base-url") + "/Shared/DocumentVerification/SearchLink?";

        $.get(url, { ids: id, docNames: docName })
            .done((result) => {
                //clear all existing hidden popups to avoid kendo id issue
                $(".site-content .popup").empty();
                const popupContainer = $(".site-content .popup").last();
                popupContainer.html(result);
                const dialog = $("#searchLinkDialog");
                dialog.unbind();
                dialog.modal("show");

                self.initializeSearchLink();
            })
            .fail(function (error) {
                pageHelper.showErrors(error);
            });
    }

    onNewDocUpload = (e) => {
        cpiLoadingSpinner.show();        
    }

    onNewDocUploadFail(e) {
        cpiLoadingSpinner.hide();
        let error = e.XMLHttpRequest.responseText;
        if (error === "")
            error = "Error occurred during upload.";
        alert(error);
    }

    onNewDocUploadSuccess = (e) => {
        cpiLoadingSpinner.hide();
        this.refreshNewDocListViewDS();
    }

    getSearchLinkCriteriaData = () => {
        var systemIds = "";
        $("input[name='basicSearchSystem']:checked").each(function () {
            systemIds += this.value + "|";
        });
        const selectedIds = $.unique(systemIds.split("|")).join("|");

        return { searchTerm: $("#BasicSearchTerm").val(), systemIds: selectedIds };
    }

    initializeSearchLink = () => {
        const dialog = $("#searchLinkDialog");
        const self = this;
        const baseUrl = $("body").data("base-url");
        $(document).ready(() => {
            dialog.find(".search-settings").hide();

            dialog.find(".saveLinks").on("click", function (e) {
                e.preventDefault();                
                self.saveSearchLink();                
            });

            dialog.find(".search-submit").on("click", function (e) {
                e.preventDefault();
                self.refreshSearchLink();
            });

            $("#BasicSearchTerm").on("keyup", (e) => {
                const keyPressed = e.key;
                if (keyPressed === "Enter") {
                    self.refreshSearchLink();
                }
            });

            dialog.find(".search-setting").on("click", function (e) {
                e.preventDefault();

                dialog.find(".search-settings").show();
                dialog.find(".mainSearchDialog").hide();

                let url = `${baseUrl}/Shared/DocumentVerification/SearchSettings`;
                $.get(url)
                    .done(function (result) {
                        dialog.find(".search-settings-detail").html(result);
                    })
                    .fail(function (e) {
                        pageHelper.showErrors(e.responseText);
                    });
            });

            dialog.on("click", ".search-settings-cancel", () => {
                dialog.find(".search-settings").hide();
                dialog.find(".mainSearchDialog").show();
            });

            dialog.on("click", ".search-settings-submit", () => {
                var selectedSearchFields = [...$('input[name=searchField]:checked')].map(e => parseInt(e.id));
                if (selectedSearchFields) {
                    const selectedIds = $.uniqueSort(selectedSearchFields);
                    let url = `${baseUrl}/Shared/DocumentVerification/EditSearchSettings`;
                    $.post(url, { keyIds: selectedIds })
                        .done(function (result) {
                        })
                        .fail((error) => {
                            pageHelper.showErrors(error)
                        });
                }
                dialog.find(".search-settings").hide();
                dialog.find(".mainSearchDialog").show();
            });

        });
    }

    saveSearchLink() {
        var docIds = $("#docIds");
        const grid = $("#searchLinkGrid").data("kendoGrid");
        const selection = grid.selectedKeyNames();

        const selectedIds = $.unique(selection);
        if (!selectedIds || selectedIds.length < 1) {
            this.cpiAlert.warning("No records selected to link");
            return;
        }

        var selectedData = [];
        var gridData = grid.dataSource.data();
        selectedIds.forEach(function (id) {
            gridData.forEach(function (dataItem) {
                if (id === dataItem.Link) {
                    selectedData.push(
                        {
                            Link: dataItem.Link,
                            SystemName: dataItem.SystemName,
                            ScreenName: dataItem.ScreenName,
                            FieldValues: dataItem.FieldValues,
                            IsActRequired: dataItem.IsActRequired,
                            Responsible: dataItem.Responsible,
                            Responsibles: (dataItem.Responsibles != null ? dataItem.Responsibles.map(d => d.Id) : [])
                        });
                }
            })
        });

        const self = this;
        let url = $("body").data("base-url");
        url += "/Shared/DocDocuments/SaveSearchLink";

        cpiLoadingSpinner.show();
        $.ajax({
            url: url,
            type: 'POST',
            data: { ids: docIds[0].value, selectedRecords: selectedData },
            dataType: "json",
            success: (response) => {
                cpiLoadingSpinner.hide();
                pageHelper.handleEmailWorkflow(response);

                const dialog = $("#searchLinkDialog");
                dialog.modal("hide");
                self.refreshNewDocListViewDS();
                self.refreshDocListView();
            },
            error: function (error) {
                cpiLoadingSpinner.hide();
                pageHelper.showErrors(error.responseText);
            }
        });
    }

    refreshSearchLink() {        
        const grid = $("#searchLinkGrid").data("kendoGrid");
        if (grid.dataSource.page() !== 1) {
            grid.dataSource.page(1);
        }
        grid.dataSource.read();
    }

    onResponsibleComboBoxChange = (e) => {
        if (e.sender) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $("#searchLinkGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            var selectedItems = [];
            if (e.sender.dataItem()) {
                var multiDataItems = e.sender.dataItems();                
                for (var i = 0; i < multiDataItems.length; i += 1) {
                    var item = multiDataItems[i];
                    selectedItems.push(item.Name);
                }
                dataItem.Responsible = selectedItems.join("; ");               
            }            
        }
    }

    onSearchLinkGridCellClose = (e) => {
        if (e.sender) {
            const rows = $(`#${e.sender.element[0].id}`).find("tr.k-master-row");
            const grid = $("#searchLinkGrid").data("kendoGrid");
            const data = grid.dataSource.data();          
            if (rows) {
                for (var i = 0; i < rows.length; i++) {                    
                    const rowData = data[i];                    
                    if (rowData && rowData.Responsible) {
                        grid.dataSource.data()[i].Responsible = rowData.Responsible;
                    }
                }
                grid.refresh();                
            }
        }
    }
    //New Documents tab - END


    getSystems(name) {
        let systems = "|";
        const systemTypes = $(name).find(".system-types input");

        $.each(systemTypes, function () {
            if (this.checked) {
                systems += this.value + "|";
            }
        });
        return { systemType: systems };
    }

    getDefaultSystems(name) {
        let systems = "|";
        const systemTypes = $(name).find(".def-system-types input");

        $.each(systemTypes, function () {
            if (this.checked) {
                systems += this.value + "|";
            }
        });
        return { systemType: systems };
    }

    redirectToAction(system, actId) {

        let url = $("body").data("base-url") + "/";

        if (system === "P")
            url = url + "Patent/ActionDue/Detail/" + actId;
        else if (system === "T")
            url = url + "Trademark/ActionDue/Detail/" + actId;
        else if (system === "G")
            url = url + "GeneralMatter/Actiondue/Detail/" + actId;

        window.open(url, '_blank');
    }

    getCriteria(name) {
        const data = pageHelper.formDataToJson($(name)).payLoad;
        if (data.Patent)
            data.Patent = "P";
        if (data.Trademark)
            data.Trademark = "T";
        if (data.GeneralMatter)
            data.GeneralMatter = "G";

        if (data.AttorneyFilter1)
            data.AttorneyFilter1 = "A1";
        if (data.AttorneyFilter2)
            data.AttorneyFilter2 = "A2";
        if (data.AttorneyFilter3)
            data.AttorneyFilter3 = "A3";
        if (data.AttorneyFilter4)
            data.AttorneyFilter4 = "A4";
        if (data.AttorneyFilter5)
            data.AttorneyFilter5 = "A5";
        if (data.AttorneyFilterR)
            data.AttorneyFilterR = "AR";

        if (data.Attorneys)
            data.Attorneys = $("#Attorneys").val();

        if (data.ActionTypes)
            data.ActionTypes = $("#ActionTypes").val();

        if (data.DocNames)
            data.DocNames = $("#DocNames_documentVerificationSearch").val();

        if (data.DocCreatedBys)
            data.DocCreatedBys = $("#DocCreatedBys").val();

        if (data.ActCreatedBys)
            data.ActCreatedBys = $("#ActCreatedBys").val();

        if (data.Responsibles)
            data.Responsibles = $("#Responsibles").val();
                    
        return data;
    }

    viewDocument(system, docFileName, parentId) {
        let url = $("body").data("base-url") + "/Shared/DocViewer/ZoomImageLink?";

        var systemName = "";
        var screenCode = "";

        if (system === "P") {
            systemName = "Patent";
            screenCode = "CA";
        }
        else if (system === "T") {
            systemName = "Trademark";
            screenCode = "Tmk";
        }
        else if (system === "G") {
            systemName = "GeneralMatter";
            screenCode = "GM";
        }

        url = url + "system=" + systemName + "&imageFile=" + docFileName + "&screenCode=" + screenCode + "&key=" + parentId + "&fileType=7";
        documentPage.zoomDocument(url);
    }

    //Edit documents from 2nd tab
    editDocument(system, parentId, docId) {        
        let url = $("body").data("base-url") + "/Shared/DocDocuments/GridUpdate?";
        var documentLink = "";

        if (system === "P") {
            documentLink = system + "|CA|AppId|" + parentId;
        }
        else if (system === "T") {
            documentLink = system + "|Tmk|TmkId|" + parentId;
        }
        else if (system === "G") {
            documentLink = system + "|GM|MatId|" + parentId;
        }

        var param = {
            documentLink: documentLink,
            id: docId
        };

        $.get(url, param)
            .done((result) => {
                //clear all existing hidden popups to avoid kendo id issue
                $(".site-content .popup").empty();
                const popupContainer = $(".site-content .popup").last();
                popupContainer.html(result);

                this.initializeEditor("documentVerificationSearchResults-Grid");
            })
            .fail((e) => {
                pageHelper.showErrors(e.responseText);
            });
    }

    //Add or edit documents from 1st tab
    editNewDocument(docId) {
        let url = $("body").data("base-url") + "/Shared/DocDocuments/NewDocUpdate?";

        var param = {
            id: docId
        };

        $.get(url, param)
            .done((result) => {
                //clear all existing hidden popups to avoid kendo id issue
                $(".site-content .popup").empty();
                const popupContainer = $(".site-content .popup").last();
                popupContainer.html(result);

                this.initializeEditor("documentVerificationNewDocGrid");
            })
            .fail((e) => {
                pageHelper.showErrors(e.responseText);
            });
    }

    //Add new document from 3rd tab
    addDocument(system, parentId, actId) {
        let url = $("body").data("base-url") + "/Shared/DocDocuments/ImageAdd?";
        var documentLink = "";

        if (system === "P") {
            documentLink = system + "|CA|AppId|" + parentId;
        }
        else if (system === "T") {
            documentLink = system + "|Tmk|TmkId|" + parentId;
        }
        else if (system === "G") {
            documentLink = system + "|GM|MatId|" + parentId;
        }

        var param = {
            documentLink: documentLink,
            folderId: 0,
            roleLink: "",
            actId: actId
        };

        $.get(url, param)
            .done((result) => {
                //clear all existing hidden popups to avoid kendo id issue
                $(".site-content .popup").empty();
                const popupContainer = $(".site-content .popup").last();
                popupContainer.html(result);

                $.when(this.initializeEditor("actionVerificationGrid")).then(
                    function (e) {
                        //add default new row for action
                        if (actId > 0) {
                            var actGrid = $("#documentVerificationActGrid").data("kendoGrid");
                            if (actGrid) {                                
                                setTimeout(() => {
                                    actGrid.addRow();
                                    var actionTypeCell = $("#documentVerificationActGrid td:eq(0)");
                                    if (actionTypeCell && actionTypeCell.length > 0) {
                                        actGrid.editCell(actionTypeCell[0]);
                                        var actionTypeCB = actionTypeCell.find("input[name='ActionType']");
                                        if (actionTypeCB) {
                                            var cbx = actionTypeCB.data("kendoMultiColumnComboBox");
                                            cbx.dataSource.read().then(function () {
                                                var data = cbx.dataSource.data();                                                
                                                cbx.select(function (dataItem) {
                                                    return dataItem.KeyId === "ActId|" + actId.toString();
                                                });
                                                cbx.trigger("change");
                                                cbx.trigger("select", { dataItem: cbx.dataItem() });
                                            });                                            
                                        }
                                    }
                                }, 500);
                            }
                        }
                    },
                    null,
                    null
                );               

            })
            .fail((e) => {
                pageHelper.showErrors(e.responseText);
            });
    }

    initializeEditor = (gridName) => {
        const self = this;
        const container = $("#documentEditorDialog");
        container.modal("show");
        const form = $("#documentEditorForm");
        form.floatLabels();

        var formChanged = false;
        form.find(":input").each(function () {
            $(this).bind("change", function () {
                formChanged = true;
            });
        });

        const cancelButton = $(container.find("#cancel"));
        cancelButton.on("click", function (e) {
            var actGrid = $("#documentVerificationActGrid").data("kendoGrid")
            if (actGrid) {
                var actGridDS = actGrid.dataSource;
                $.each(actGridDS._data, function ()
                {
                    if (this.dirty == true)
                    {
                        formChanged = true;
                    }
                });
            }   

            if (formChanged && !confirm(container.data("cancel-message"))) {                
                e.stopPropagation();                
            }
        });

        // configure form submit logic
        form.submit((e) => {
            e.preventDefault();                       
            
            if (!this.validateUploadAction())
                return;

            pageHelper.hideErrors();

            var form = $("#documentEditorForm");
            var formData = new FormData(form[0]);

            var actGrid = $("#documentVerificationActGrid").data("kendoGrid");
            //show error if IsActRequired = true and Action grid is empty
            if (formData && formData.has('IsActRequired') && formData.get('IsActRequired') === 'true' && actGrid) {
                var gridData = actGrid.dataSource.data();
                if (gridData && gridData.length <= 0) {
                    alert(container.data("missing-action"));
                    return;
                }                
            }

            //auto save changes on Action grid            
            if (actGrid && actGrid.dataSource.hasChanges()) {
                //var emptyBaseDateItems = actGrid.dataSource.data().filter((item) => (item.BaseDate === "" || !item.BaseDate));
                //if (emptyBaseDateItems && emptyBaseDateItems.length > 0) {
                //    alert(container.data("missing-basedate"));
                //    return;
                //}

                $.when(pageHelper.kendoGridSave({
                    name: 'documentVerificationActGrid'
                    //popup windows closes after saving, no need to refresh
                    //,afterSubmit: () => { $("#documentVerificationActGrid").data("kendoGrid").dataSource.read(); }
                })).then(
                    function (e) {
                        save();
                    },
                    function (e) {
                        alert(e);
                        return;
                    },
                    null
                );
            }
            else {
                save();
            }

            function save() {
                cpiLoadingSpinner.show();            
                $.ajax({
                    type: "POST",
                    url: form.attr("action"),
                    data: formData,
                    contentType: false, // needed for file upload
                    processData: false, // needed for file upload
                    success: (response) => {
                        cpiLoadingSpinner.hide();
                        pageHelper.handleEmailWorkflow(response);
                        //this.refreshDisplay(true);
                        $("#documentEditorDialog").modal("hide");

                        //refresh grid
                        if (gridName === "documentVerificationNewDocGrid")
                            self.refreshNewDocListViewDS();
                        else if (gridName === "documentVerificationSearchResults-Grid")
                            self.refreshDocListView();
                        else if (gridName === "actionVerificationGrid")
                            self.refreshActListView();
                    },
                    error: function (e) {
                        cpiLoadingSpinner.hide();
                        pageHelper.showErrors(e);
                    }
                });
            }
            
        });
    }

    validateUploadAction = () => {
        const container = $("#documentEditorDialog");

        const isInsertAction = () => {
            const el = container.find("#DocId");
            const id = el.val();

            if (id == 0) //should be ==
                return true;
            else
                return false;
        };

        const isEmpty = (name) => {
            const el = container.find("input[name=" + name + "]");
            if (el.length > 0) {
                const value = el.val();
                if (value === "") {
                    return true;
                }
            }
            return false;
        };

        const showError = (name) => {
            const el = container.find("input[name=" + name + "]");
            if (el.length > 0) {
                const error = el.val();
                pageHelper.showErrors(error);
            }
        };

        const action = container.find("input[name=DocTypeId]").data("kendoComboBox").text().toLowerCase();
        if (action === "link") {
            container.find("input[name=FileId]").val("");
            if (isEmpty("DocUrl")) {
                showError("UrlError");
                container.find("#urlRow").addClass("border border-danger");
                return false;
            }
        }
        else {
            container.find("input[name=DocUrl]").val("");
            if (isEmpty("UploadedFiles") && isInsertAction()) {
                showError("UploadedFilesError");
                container.find("#uploadImageRow").addClass("border border-danger");
                return false;
            }
        }
        
        //else if (action === "copyImage") {
        //    if (isEmpty("ImageSelected")) {
        //        showError("ImageSelectedError");
        //        return false;
        //    }
        //}
        return true;
    }

    openAddAction(system, parentId, actionTypeId) {
        let url = $("body").data("base-url");
        let area = "";

        if (system === "P") {
            area = "Patent";
        }
        else if (system === "T") {
            area = "Trademark";
        }
        else if (system === "G") {
            area = "GeneralMatter";
        }

        url = url + "/" + area + "/ActionDue/DetailLink?id=0&parentId=" + parentId + "&actionTypeId=" + actionTypeId;
        window.open(url, "_blank");
    }

    refreshCriteriaDS() {
        $("select[data-role='multiselect']").each(function () {
            const multi = $(this).data("kendoMultiSelect");
            if (multi) {
                multi.dataSource.read();
            }
        });
        $("input[data-role='combobox']").each(function () {
            const cbBox = $(this).data("kendoComboBox");
            if (cbBox) {
                cbBox.dataSource.read();
            }
        });
    }

    refreshToDoCount = () => {
        const docVerificationCount = $(".nav-login .badge.doc-verification-count");
        if (docVerificationCount) {
            const url = docVerificationCount.data("url");
            if (url) {
                $.get(url)
                    .done((response) => {
                        docVerificationCount.text(response.ToDoItemCount > 0 ? response.ToDoItemCount : "");
                    });
            }
        }
    }

    allowDropMail = (event) => {
        event.preventDefault();
    }

    dropMail = (event) => {
        event.preventDefault();

        const el = $(event.target);
        const dropZone = el.closest("#DropZone");
        const targetId = event.dataTransfer.getData("targetId");
        const mailbox = event.dataTransfer.getData("mailbox");
        let messageIds = [];

        const updateStatus = (status) => {
            localStorage.setItem(targetId, status);
        }

        const cancelDrop = (wait) => {
            if (wait)
                setTimeout(() => {
                    updateStatus("cancel");
                }, wait);
            else
                updateStatus("cancel");
        }

        if (event.dataTransfer.getData("hasAttachments")) 
            messageIds = JSON.parse(event.dataTransfer.getData("hasAttachments"));

        const saveMessage = () => {
            const url = dropZone.data("save-email-url");

            if (url) {
                const verificationToken = $(this.refineSearchContainer).find("input[name=__RequestVerificationToken]").val()

                cpiLoadingSpinner.show();
                $.post(url, { ids: messageIds, mailbox: mailbox, __RequestVerificationToken: verificationToken })
                    .done((response) => {
                        cpiLoadingSpinner.hide();
                        updateStatus("ok");
                        this.refreshNewDocListViewDS();
                    })
                    .fail((error) => {
                        cpiLoadingSpinner.hide();
                        updateStatus("fail");
                        pageHelper.showErrors(error);
                    });
            }
            else {
                cancelDrop(1000);
            }
        }

        if (messageIds.length > 0) {
            let dropConfirm = messageIds.length == 1 && event.dataTransfer.getData("sender") ? dropZone.data("drop-confirm") : dropZone.data("drop-confirm-multiple");

            if (dropConfirm) {
                dropConfirm = dropConfirm.replace("{subject}", event.dataTransfer.getData("subject")).replace("{sender}", event.dataTransfer.getData("sender")).replace("{count}", messageIds.length);

                cpiConfirm.confirm(window.cpiBreadCrumbs.getTitle(), dropConfirm, saveMessage, null, null, () => {
                    cancelDrop();
                });
            }
            else
                saveMessage();
        }
        else {
            const noAttachmentsWarning = dropZone.data("drop-no-attachments");
            if (noAttachmentsWarning)
                cpiAlert.warning(dropZone.data("drop-no-attachments"));

            cancelDrop(1000);
            return;
        }
    }

    //refreshNewDocuments = () => {
    //    const grid = $(this.searchResultContainer).find("#documentVerificationNewDocGrid").data("kendoListView");
    //    grid.dataSource.read();
    //}
    
}
//TN 20240611